import { render, staticRenderFns } from "./UpdateDivisionHead.vue?vue&type=template&id=760a8ccb&scoped=true&"
import script from "./UpdateDivisionHead.vue?vue&type=script&lang=js&"
export * from "./UpdateDivisionHead.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDivisionHead.vue?vue&type=style&index=0&id=760a8ccb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760a8ccb",
  null
  
)

export default component.exports